<template>
  <div class="header-bar flex-row flex-between">

    <template v-if="showBack || miniLogo">
      <div v-if="showBack" class="back-btn flex-center" @click="backHome">
        <Icon type="ios-home-outline" size="20" class="mr-5" />返回首页
      </div>
      <div class="flex-row">
        <img src="@/assets/logo.png" class="logo" />
        <div class="header-title">{{ headerTitle }}</div>
      </div>
    </template>
    <div v-else class="flex-row">
      <img
        src="https://easystock.oss-cn-hangzhou.aliyuncs.com/3f5685f520b54542aad05992d0cf8edb.png"
      />
      <div class="header-title">{{ headerTitle }}</div>
    </div>
    <div v-if="showSearch" class="flex-row">
      <div class="icon-outer flex-row">
        <Icon type="ios-search" size="18" color="#999" />
      </div>
      <AutoComplete
        v-model="keyword"
        @on-change="handleSearch"
        @on-select="handleSelect"
        placeholder="搜索"
        size="large"
        :transfer="true"
        class="auto-complete"
      >
        <template v-if="keyword">
          <template v-if="result.length">
            <div
              v-for="(item, index) in result"
              :key="index"
              class="result-item"
            >
              <div class="result-title" v-html="item.title"></div>
              <Option :value="item.hitword"
                ><div
                  class="result-content ellipsis-x2"
                  v-html="item.content"
                  @click="click(item)"
                >
                  <!-- {{ item.content }} -->
                </div></Option
              >
            </div>
          </template>
          <div v-else class="result-item">
            未找到有关<span class="result-keyword ml-5 mr-5">{{ keyword }}</span
            >的相关内容
          </div>
        </template>
      </AutoComplete>
    </div>
    <div v-else class="flex-row">
        <div v-if="showHelpExtra" class="flex-row cursor-pointer" @click="toHelp"><img src="@/assets/help_icon.png" style="width: 20px;height: 24px" />帮助文档</div>
        <div v-if="showKefuExtra" id="kefu" class="flex ml-40 cursor-pointer" style="margin-right: 20px"><kefu v-if="showKefuExtra" />客服</div>
      <user ref="user" />
    </div>
  </div>
</template>

<script>
import User from "../user";
import Kefu from '../../../Kefu'
import { menuList } from "@/views/help/config";
import { getCurrentType } from "@/libs/util";
export default {
  name: "HeaderBar",

  components: {
    User,
    Kefu
  },

  data() {
    return {
      headerTitle: "应用平台",
      showBack: false,
      miniLogo: false,
      showSearch: false,
      keyword: "",
      result: [],
      menuList,
      showKefuExtra: false,
      showHelpExtra: false
    };
  },

  watch: {
    $route: "handlePath",
  },

  mounted() {
    // var mnName = "你好，内蒙。蒙古";
    // console.log(mnName.split(/[᠃，.。]/));
    this.handlePath();
  },

  methods: {
    // 监听路由变化
    handlePath() {
      let { name, params, query } = this.$route;
      console.log(name, params, query);
      let { desc, showBack, miniLogo, showSearch } = this.$route.meta;
      this.headerTitle = desc || "应用平台";
      this.showBack = !!showBack;
      this.miniLogo = !!miniLogo;
      this.showSearch = !!showSearch;
      if (this.$config.KEFU_WHITE.includes(name)) {
        this.showKefuExtra = true
      } else {
        this.showKefuExtra = false
      }
      if (name === "subApp") {
        let match = params.pathMatch.split("/")[0];
        if (match === "qhd") this.headerTitle = "趣互动管理中心";
        if (match === "beauty") this.headerTitle = "医美会员中心";
        this.showHelpExtra = true
      } else {
        this.showHelpExtra = false
      }
      if (name === "help") {
        this.activeName = query.activeName || "0-0";
      }
      if (!this.showSearch) this.$refs.user.checkToken();
    },

    backHome() {
      this.$router.push({
        name: this.$config.HOME_PAGES[getCurrentType()],
      });
    },

    handleSearch(e) {
      let result = [];
      let menuList = JSON.parse(JSON.stringify(this.menuList));
      menuList.forEach((item, index) => {
        item.subList.forEach((it, idx) => {
          let title = it.title || "";
          let content = it.content || "";
          it.hitword = e;
          let flag = false;
          if (title.indexOf(e) !== -1) {
            let reg = new RegExp(`${e}`, "g");
            let newVal = `<span style="font-weight: 600;color: #333;">${e}</span>`;
            title = title.replace(reg, newVal);
            it.title = title;
            it.activeName = `${index}-${idx}`;
            flag = true;
          }
          let list = content.split(/[，,᠃.。]/);
          try {
            list.forEach((x, y) => {
              if (x.indexOf(e) !== -1) {
                let reg = new RegExp(`${e}`, "g");
                let newVal = `<span style="font-weight: 600;color: #333;">${e}</span>`;
                content = x.replace(reg, newVal);
                it.content = content;
                it.activeName = `${index}-${idx}`;
                flag = true;
                throw Error();
              }
            });
          } catch (e) {}
          it.activeName;
          if (flag) {
            result.push(it);
          }
        });
      });
      this.result = result;
    },

    handleSelect(e, opt) {},

    click(item) {
      this.$router.push({
        name: "help",
        query: {
          activeName: item.activeName,
        },
      });
    },

    toHelp() {
      const newUrl = this.$router.resolve({ name: "help" });
      window.open(newUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  position: relative;
  // min-width: 1000px;
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-shadow: 0px 1px 4px 0px #e3d0ff;
  z-index: 999;
}

.back-btn {
  width: 130px;
  height: 36px;
  border-radius: 3px;
  border: 1px solid #333333;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  cursor: pointer;
}

.header-title {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 42px;
  margin-left: 10px;
}

.logo {
  width: 65px;
  height: 35px;
}

.icon-outer {
  // width: 30px;
  height: 40px;
  background: #f0f5f5;
  padding-left: 10px;
  border-radius: 20px 0 0 20px;
}

.result-item {
  width: 400px;
  padding: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  word-break: break-all;
}

.result-keyword {
  font-weight: 600;
  color: #333;
}

.result-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.result-content {
  width: 300px;
}
</style>

<style lang="less">
.auto-complete {
  .ivu-input {
    border: none;
    border-radius: 0 20px 20px 0;
    background: #f0f5f5;
  }
  .ivu-input:focus {
    outline: none;
    border: none;
    box-shadow: 0 0 0 2px transparent;
  }
  .ivu-select-dropdown {
    right: 10px !important;
  }
}

.result-item {
  .ivu-select-item {
    padding: 7px 0 !important;
    white-space: normal !important;
  }
}
.duqGkC {
  position: relative;
  top: 7px;
  right: 490px !important;
}

.kdqgRq {
  zoom: 0.6;
}
</style>